import * as React from 'react';
import * as classes from '@common/components/section/section.scss';

export const Section = (props: any) => (
  <section className={classes.section}>
    {props.title ? <h2>{props.title}</h2> : ''}
    {props.children}
  </section>
);



// WEBPACK FOOTER //
// ./src/common/components/section/section.tsx